import { _isNumberValue } from "@angular/cdk/coercion";
import { isNullOrUndefined } from "../../_helpers";
import { ComboGroupRecords, ComboRecord } from "../front/combox/ComboRecord";

/**
 * Class API Back reprenant 1 groupement de console
 * 
 */
export class ApiExportGroupDevices {

   //#region Config
    /**
     * Code du groupe "referentiel de modèles de console"
     */
    public static CODE_GROUP_REFERENTIAL_MODELS =  "MODELS_DEVICES"
    
    /**
     * Code du groupe "consoles utilisateur"
     */
    public static CODE_GROUP_USER_DEVICES =  "USER_DEVICES"

    /**Mode affichage des consoles exportable
     *  true: seul les perso sont affichées, false les perso et referentiel des modèles sont affichés */
    public static MODE_USER_DEVICES_ONLY = true;

    //#endregion
    /**
     * Code identifiant le groupement
     * peut ne pas etre unique si on separe les connectés des usb perso
     */
    Code: string = "";

    /**
     * si groupement individuel le type de console
     * [null, 0 = Referential, 1 = PersonalUSB, 2 = PersonalConnected]
     */
    UniqueType: number | null = null;
    /**
    * Nom du groupement de console
    */
    Name: string = "";
    /** Description du groupe */
    Description: string = "";

    /**
     * les consoles du groupement
     */
    Devices: ApiExportableDevice[] = [];

    /**
     * Retourne si on est sur un groupement référentiel des modèles de console
     */
    public get IsGroupRefModels() {
        return this.Code === ApiExportGroupDevices.CODE_GROUP_REFERENTIAL_MODELS
    }

    /**
    * Retourne si on est sur un groupement de console perso de l'utilisateur
    */
    public get IsGroupUserDevices() {
        return this.Code === "USER_DEVICES"
    }

    /**
     * Retourne si exception lors du chargment des consoles utilisateur
     */
    public get IsGroupUserDeviceFailed() {
        return this.Code === "USER_DEVICES_FAILED";
    }

    /**
    * Retourne si exception lors du chargment du référentiel des modèles de console
    */
    public get IsGroupRefModelDeviceFailed() {
        return this.Code === "MODELS_DEVICES_FAILED";
    }

    /**
    * Indique si il dispose de console dans ce groupement
    * @returns 
    */
    public Exists(): boolean {
        return this?.Devices?.length > 0;
    }

      /**
    * Initialise 1 objet depuis le json ApiExportGroupDevices
    * de sort à pouvoir utiliser les fonction des class et sous class
    * @param _iJsonApiExportGroupDevices Json ApiExportGroupDevices
    * @returns ApiExportGroupDevices
    */
    static fromJson(_iJsonApiExportGroupDevices: any): ApiExportGroupDevices {
        let oDevice = new ApiExportGroupDevices();
        oDevice.Code = _iJsonApiExportGroupDevices.Code;
        oDevice.Name = _iJsonApiExportGroupDevices.Name;
        oDevice.Description = _iJsonApiExportGroupDevices.Description;
        oDevice.UniqueType = _iJsonApiExportGroupDevices.UniqueType;
        oDevice.Devices = [];
        if (_iJsonApiExportGroupDevices.Devices && _iJsonApiExportGroupDevices.Devices.length > 0) {
            let grp: ApiExportableDevice[] = [];
            _iJsonApiExportGroupDevices.Devices.forEach((element: any) => {
                grp.push(ApiExportableDevice.fromJson(element));
            });
            oDevice.Devices = [...grp];
        }
        return oDevice;
    }

}

/**
 * Class Back comportant les groupements de consoles perso & models
 * 
 */
export class ApiExportGroupsDevices extends Array<ApiExportGroupDevices> {
    /**Id du terminal favoris (precedement exporté si tjs dans la liste) */
    public FavoriteId: string | null = null;
    /**Type du terminal favoris (precedement exporté si tjs dans la liste) */
    public FavoriteTypeId: number | null = null;

    constructor() {
        super();
    }

     /**Suppression de l'ensemble des données */
    private Clear(){
        this.length = 0;
    }

    /**
      * Mapping vers le format combo Grouped records
      * @param _iUniqueUSbModels Indique si on disinct sur le modele pour les USB(priorité aux USB perso)
      * @returns 
      */
    public MapToComboReferential(_iUniqueUSbModels: boolean): ComboGroupRecords[] {
        let oComboGrpDevices = new Array<ComboGroupRecords>();
        let lineBreak = "\n";
        if (this?.length > 0) {
            let uniqueModelCodes: string[] = [];
            for (let ndxGroup = 0; ndxGroup < this.length; ndxGroup++) {
                let groupedDevices = new Array<ComboRecord>();
                let fGrp = this[ndxGroup];
                //si groupe de consoles perso
                let isPersonal = fGrp.IsGroupRefModels === false;

                for (let ndx = 0; ndx < fGrp.Devices.length; ndx++) {
                    var fDevice = fGrp.Devices[ndx];
                    let manufactur = fDevice?.Manufacturer?.Name ?? "";

                    if (_iUniqueUSbModels && fDevice.IsUSBSupport && fDevice.Model?.Code) {
                        if (isPersonal) {
                            uniqueModelCodes.push(fDevice.Model.Code);
                        } else if (uniqueModelCodes.includes(fDevice.Model.Code)) {
                            //modèle standard déja présent dans les usb perso
                            continue;
                        }
                    }
                    let icone = '';
                    let iconeTooltip = '';
                    let Description = "Console ";
                    //termes de recherche complémentaire autre que le label formaté
                    let searching = fGrp.Name + " " + fDevice?.Manufacturer?.Name + " " + fDevice?.Model?.Name;

                    let showName = manufactur + " - " + fDevice.Name;

                    if (fDevice.IsConnectedDevice) {
                        showName = fDevice.Name;
                        Description += "connectée"
                        icone = 'icon12-tractorConnected'
                        iconeTooltip = "Console personnalisée - connectée"
                        if (fDevice?.Account?.Name) {
                            iconeTooltip += lineBreak + "Compte : " + fDevice?.Account?.Name;
                        }
                        if (fDevice?.Manufacturer?.Name) {
                            iconeTooltip += lineBreak + "Constructeur : " + fDevice?.Manufacturer?.Name;
                        }
                        if (fDevice?.Model?.Name) {
                            iconeTooltip += lineBreak + "Modèle : " + fDevice?.Model?.Name;
                        }
                        searching += " " + fDevice?.Account?.Name + " Console personnalisée connectée console connectée compte connecté sans fil"
                    } else if (fDevice.IsPersonalDevice) {

                        showName = fDevice.Name;

                        Description += "personnalisée"
                        icone = 'icon12-usb-green'
                        iconeTooltip = "Console personnalisée - USB "
                        if (fDevice?.Manufacturer?.Name) {
                            iconeTooltip += lineBreak + "Constructeur : " + fDevice?.Manufacturer?.Name;
                        }
                        if (fDevice?.Model?.Name) {
                            iconeTooltip += lineBreak + "Modèle : " + fDevice?.Model?.Name;
                        }
                        searching += " personnelle USB console USB"
                    }
                    else if (fDevice.IsReferentialModel) {
                        Description = "Modèle de console"
                        icone = 'icon12-usb-grey'
                        iconeTooltip = "Modèle de console"
                        searching += "Modèle USB"
                    }

                    //le code du modele est passé utile à l epxort
                    //l id est passé 
                    groupedDevices.push(new ComboRecord(showName, fDevice.Name, fDevice.Id, fDevice.Model.Code, icone, iconeTooltip, Description, searching, fDevice.IsPreselected == true));

                }
                if (groupedDevices.length > 0) {
                    /* ORDONNE les consoles */
                    if (groupedDevices.length > 1) {
                        groupedDevices = groupedDevices.sort(function (a, b) {
                            return (isNullOrUndefined(a.Label)) ? -1 : (isNullOrUndefined(b.Label)) ? 1 : (a.Label < b.Label) ? -1 : (a.Label > b.Label) ? 1 : 0;
                        });
                    }

                    oComboGrpDevices.push(new ComboGroupRecords(fGrp.Code, fGrp.Name, groupedDevices));
                }
            }
        }
        return oComboGrpDevices;
    }

    /**
     * Suppression des groupes non "Référentiel des modèles" de console
     * donc des consoles perso
     */
    public PreserveOnlyReferentialModels() {
        let ref = this.filter(t => t && t.IsGroupRefModels == true);
        this.Clear();
        this.push(...ref);
       
    }

   

    /**
     * Suppression de groupes de consoles en echec
     */
    public RemoveFailedGroups() {
        this.push(...this.filter(t => t.IsGroupUserDeviceFailed == false && t.IsGroupRefModelDeviceFailed == false));
    }

    /**
     * Attribution de la console favorite à l'objet
     * @param _iPreselectedDevice console preselectionnée depuis le back (favorite)
     */
    public SetFavorite(_iPreselectedDevice: ApiExportableDevice | undefined) {
        this.FavoriteId = _iPreselectedDevice!.Id;
        this.FavoriteTypeId = _iPreselectedDevice!.Type;
    }

    /**
     * Attribution de la preselection de la console si la favorite existe toujours
     * null aucun favorit présent dans l'objet, true: favoris present et preselectionné, false: favoris plus present dans la liste des devices
     */
    public PreselectFavorite(): boolean | null {
        let oFounded = null;
        if (this.FavoriteId && this.FavoriteTypeId != null) {
            oFounded = false;
            oFounded = this.PreselectDeviceId(this.FavoriteId);
        }
        return oFounded;
    }

    /**
     * Preselectionne la console selon son id
     * @param _iUniqueDeviceId ide unique de la console à préselectionner si null toutes les consoles seront en non preselected
     * @returns 
     */
    private PreselectDeviceId(_iUniqueDeviceId: string | null) {
        let cntPreselected = 0;
        if (this.Exists()) {
            this.forEach((fGroup: ApiExportGroupDevices) => {
                if (fGroup?.Exists() == true) {
                    fGroup.Devices.forEach((fDevice: ApiExportableDevice) => {
                        fDevice.IsPreselected = _iUniqueDeviceId != null && fDevice.Id == _iUniqueDeviceId;
                        if (fDevice.IsPreselected) {
                            cntPreselected++;
                        }
                    })
                }
            })
        }
        return cntPreselected > 0;
    }

    /**
     * Indique si il dispose de groupement de consoles
     * @returns 
     */
    public Exists(): boolean {
        return this?.length > 0;
    }

    /**
     * Retourne le device selon son id
     * @param _iUniqueId id console
     * @returns 
     */
    public GetByUniqueId(_iUniqueId: string): ApiExportableDevice | undefined {
        let oDevice = undefined;
        let found = false;
        this.forEach((fGrp: ApiExportGroupDevices) => {
            if (!found && fGrp?.Exists()) {
                if (fGrp.Devices.findIndex(t => t.Id == _iUniqueId) > -1) {
                    oDevice = fGrp.Devices.find(t => t.Id == _iUniqueId);
                    found = true;
                }
            }
        })
        return oDevice;
    }

    /**
     * Indique si il dispose d'un groupement utilisateur en erreur api
     * @returns 
     */
    public GetGroupUserFailed(): ApiExportGroupDevices | undefined {
        return this.Exists() ? this.find(t => t.IsGroupUserDeviceFailed) : undefined;
    }

    /**
    * Indique si il dispose d'un groupement référentiel modèle en erreur api
    * @returns 
    */
    public GetGroupRefModelFailed(): ApiExportGroupDevices | undefined {
        return this.Exists() ? this.find(t => t.IsGroupRefModelDeviceFailed) : undefined;
    }

        /**
     * Initialise l'objet depuis le json ApiExportGroupsDevices
     * de sort à pouvoir utiliser les fonction des class et sous class
     * @param _iJsonApiExportGroupsDevices Json ApiExportGroupsDevices
     * @param _iRecoverFavorite true on recupere depuis la liste des device celle preselectionnée (favorite)
     * @param _iPreselectFavorite true on recherche la console favorite connu et met en preselection
     * @returns 
     */
    static fromJson(_iJsonApiExportGroupsDevices: any, _iRecoverFavorite: boolean, _iPreselectFavorite: boolean): ApiExportGroupsDevices {
       
        let oDevice = new ApiExportGroupsDevices();
        let isFavoriteLoaded = false;

        if (_iJsonApiExportGroupsDevices.FavoriteId) {
            //on est sur le chargement complet si on est depuis le back
            oDevice.FavoriteId = _iJsonApiExportGroupsDevices.FavoriteId;
            oDevice.FavoriteTypeId = _iJsonApiExportGroupsDevices.FavoriteId;
            isFavoriteLoaded = true;
        }
      
        if (_iJsonApiExportGroupsDevices && _iJsonApiExportGroupsDevices?.length) {
            _iJsonApiExportGroupsDevices.forEach((fJsonGroupDevices: any) => {
                let oGrp = ApiExportGroupDevices.fromJson(fJsonGroupDevices);
                if (!isFavoriteLoaded && _iRecoverFavorite && oGrp?.Devices.findIndex(t => t.IsPreselected) > -1) {
                    //on récupère
                    oDevice.SetFavorite(oGrp.Devices.find(t => t.IsPreselected));
                }
                oDevice.push(oGrp)
            });
        }

        if (_iPreselectFavorite) {
            oDevice.PreselectFavorite();
        }

        return oDevice;
    }
}


/**
 * Class Back console perso ou modèle standard
 * 
 */
export class ApiExportableDevice {
    /**Indique si c est depuis le bac  la console favorite (dernière exportée)*/
    IsPreselected: boolean = false;
    /**informations du modèle de la console*/
    Model: ApiExportableModelDevice = new ApiExportableModelDevice();
    /**informations du constructeur de la console*/
    Manufacturer: ApiExportableManufacturerDevice = new ApiExportableManufacturerDevice();

    /**Id de la console: UID une perso string si on est sur un modele de console*/
    Id: string = "";
    /**Nom de la console perso ou nom du modele sur un modele de console*/
    Name: string = "";
    /**Référence du support de la console*/
    Support: number | null = null;
    /**Référence du type de la console*/
    Type: number | null = null;
    /**Informations du compte lié sur une console connectée*/
    Account: ApiExportableAccountDevice | null = null;

    /**Indique si c est une console ou modèle USB */
    public get IsUSBSupport() {
        return this.Support === 1 // USB = 1,
    }

    /**Indique si c est une console Connectée (compte) */
    public get IsConnectedSupport() {
        return this.Support === 2 // CONNECTED = 2
    }

    /**Indique si c est un modèle du référentiel (USB) */
    public get IsReferentialModel() {
        return this.Type === 0 // Referential=0
    }

    /**Indique si c est une console perso utilisateur (USB) */
    public get IsPersonalDevice() {
        return this.Type === 1 // Personal=1,
    }

    /**Indique si c est une console perso connecté  (Compte connecté) */
    public get IsConnectedDevice() {
        return this.Type === 2 //  Account=2
    }

    constructor() { }

    /**
    * Initialise 1 objet depuis le json ApiExportableDevice
    * de sort à pouvoir utiliser les fonction des class et sous class
    * @param _iJsonApiExportGroupDevices Json ApiExportableDevice
    * @returns ApiExportableDevice
    */
    static fromJson(_iJsonApiDevice: any): ApiExportableDevice {
        let oDevice = new ApiExportableDevice();
        oDevice.Id = _iJsonApiDevice.Id;
        oDevice.Name = _iJsonApiDevice.Name;
        oDevice.Manufacturer = new ApiExportableManufacturerDevice();
        oDevice.Manufacturer.Code = _iJsonApiDevice.Manufacturer?.Code
        oDevice.Manufacturer.Id = _iJsonApiDevice.Manufacturer?.Id
        oDevice.Manufacturer.Name = _iJsonApiDevice.Manufacturer?.Name
        oDevice.IsPreselected = _iJsonApiDevice.IsPreselected;
        oDevice.Model = new ApiExportableModelDevice();
        oDevice.Model.Code = _iJsonApiDevice.Model?.Code
        oDevice.Model.Id = _iJsonApiDevice.Model?.Id
        oDevice.Model.Name = _iJsonApiDevice.Model?.Name;
        oDevice.Support = _iJsonApiDevice.Support;
        oDevice.Type = _iJsonApiDevice.Type;
        if (_iJsonApiDevice.Account && _iJsonApiDevice.Account?.UID) {
            oDevice.Account = new ApiExportableAccountDevice();
            oDevice.Account.UID = _iJsonApiDevice.Account.UID
            oDevice.Account.Name = _iJsonApiDevice.Account.Name
        }
        return oDevice;
    }

}

/**
 * Class API Back modele de console
 * 
 */
export class ApiExportableModelDevice {
    /**Code du modèle*/
    Code: string = "";
    /**Id du modèle*/
    Id: number | null = null;
    /**Nom du modèle*/
    Name: string = "";
}

/**
 * Class API Back Constructeur de la console
 * 
 */
export class ApiExportableManufacturerDevice {
    /**Code du constructeur*/
    Code: string = "";
    /**Id du constructeur*/
    Id: number | null = null;
    /**Nom du constructeur*/
    Name: string = "";
}

/**
 * Class API Back compte connecté
 * 
 */
export class ApiExportableAccountDevice {
    /**Uid du compte connecté */
    UID: string | null = null;
    /**Nom du compte connecté */
    Name: string = "";
}

